import { z } from "zod";
/** report-lifecycle.v1.0 — Tier 1 Step 7 report record states */
export const ReportLifecycleStatusSchema = z.enum([
    "DRAFT",
    "GENERATING",
    "READY_INTERNAL",
    "READY_CLIENT_SAFE",
    "SUPERSEDED",
    "ARCHIVED",
    "FAILED",
]);
export const ReportTypeSchema = z.enum([
    "SEARCH_READINESS",
    "LAUNCH_READINESS_DIRECTION",
    "LAUNCH_PROOF",
    "EXTERNAL_READINESS",
]);
export const ReportVariantSchema = z.enum(["INTERNAL", "CLIENT_SAFE"]);
/** Step 7 rule catalog pin (meaning in T1-D-009; IDs evaluated at compose time). */
export const SEARCH_READINESS_RULE_SET_VERSION = "search-readiness-rules.v1.0";
/** Launch Proof compose + Phase 1 pack pin for ReportSnapshot idempotency. */
export const LAUNCH_PROOF_RULE_SET_VERSION = "launch-proof-rules.v1.0";
/** Phase 4 — external site readiness from scan/import/confirmation evidence. */
export const EXTERNAL_READINESS_RULE_SET_VERSION = "external-readiness-rules.v0.1";
/** Phase 5 — external proof wave Fix Kit from readiness report findings. */
export const EXTERNAL_PROOF_FIX_KIT_RULE_SET_VERSION = "external-proof-fix-kit-rules.v0.1";
/** Phase 6 — external proof Sales Room / Client Link client-safe view. */
export const EXTERNAL_PROOF_SALES_ROOM_RULE_SET_VERSION = "external-proof-sales-room-rules.v0.1";
/** Phase 7 — after-fix re-scan proof comparison from prior + new scan evidence. */
export const EXTERNAL_AFTER_FIX_PROOF_RULE_SET_VERSION = "external-after-fix-proof-rules.v0.1";
//# sourceMappingURL=report-lifecycle.js.map